/**
 * @hidden
 */
export function toIsoString(date: Date, includeMillis?: boolean): string;

/**
 * @hidden
 */
export function toIsoString(date: undefined, includeMillis?: boolean): undefined;

/**
 * @hidden
 */
export function toIsoString(date: null, includeMillis?: boolean): null;

/**
 * @hidden
 */
export function toIsoString(date: Date | undefined, includeMillis?: boolean): string | undefined;

/**
 * @hidden
 */
export function toIsoString(date: Date | null, includeMillis?: boolean): string | null;

export function toIsoString(date: Date | undefined | null, includeMillis?: boolean): string | undefined | null;

export function toIsoString(date: Date | undefined | null, includeMillis = false): string | undefined | null {
  if (typeof date === 'undefined') {
    return undefined;
  } else if (date === null) {
    return null;
  } else {
    // javascript toISOString includes millis
    // to emulate java we need to trim off the millis
    if (includeMillis) {
      return date ? date.toISOString() : undefined;
    } else {
      return date ? date.toISOString().slice(0,-5)+"Z" : undefined;
    }
  }
}
